import { useEffect, useState } from 'react'

import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer'
import { useQuery } from '@tanstack/react-query'

import { queryGenerateCv } from '@/services/user/query'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

import TemplateCvJapan from '../template-cv/template-cv-japan'

interface DialogPreviewCvProps {
  open: boolean
  setOpen: (open: boolean) => void
}
export default function DialogPreviewCv({
  open,
  setOpen,
}: DialogPreviewCvProps) {
  const { data, refetch, isLoading, isFetching, isSuccess, isError } =
    useQuery(queryGenerateCv())

  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (open) {
      refetch()
    }
  }, [open])

  useEffect(() => {
    let interval: NodeJS.Timeout

    if (isFetching) {
      setProgress(10)
      interval = setInterval(() => {
        setProgress((prev) => (prev < 90 ? prev + 10 : prev))
      }, 300)
    } else {
      setProgress(100)
      setTimeout(() => setProgress(0), 500)
    }

    return () => clearInterval(interval)
  }, [isFetching])

  return (
    <>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="w-full max-w-[794px]">
          <DialogHeader className="flex-column flex justify-between">
            <DialogTitle className="flex justify-between px-8">
              <div>Generate CV</div>
              <div>
                {data && (
                  <PDFDownloadLink
                    //  @ts-expect-error
                    document={<TemplateCvJapan dataPayload={data} />}
                    fileName="yes-academy-cv-japanese.pdf"
                  >
                    {({ blob, url, loading, error }) => (
                      <Button>
                        {loading ? 'Loading download...' : 'Download now!'}
                      </Button>
                    )}
                  </PDFDownloadLink>
                )}
              </div>
            </DialogTitle>
          </DialogHeader>
          <div className="h-[800px] w-full overflow-auto">
            {/* Progress Bar */}
            {isFetching && (
              <div className="relative mt-2 mt-32 h-2 w-full rounded-md bg-gray-200">
                <div
                  className="h-2 rounded-md bg-primary-yes transition-all"
                  style={{ width: `${progress}%` }}
                />
                <div className="flex justify-center text-center">{`${progress}%`}</div>
              </div>
            )}
            {data && (
              <PDFViewer className="h-full w-full" showToolbar={false}>
                {/* @ts-expect-error */}
                <TemplateCvJapan dataPayload={data} />
              </PDFViewer>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
